module.exports = __webpack_public_path__ + "img/VIC-Before.2039b940.png";